import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/Icon/Icon';
import './SDUI.scss';

/**
 * Clarification - Requests clarification from the user with predefined options
 * 
 * @param {string} question - The clarification question
 * @param {Array} options - Available choices
 * @param {Function} onChoice - Callback when choice is made
 */
export const Clarification = ({ question, options, onChoice }) => {
  const handleChoice = (option) => {
    if (onChoice) {
      onChoice(option);
    }
  };

  return (
    <div className='sdui-clarification'>
      <div className='clarification-header'>
        <Icon name='Question' size='sm' />
        <span className='title'>Clarification Needed</span>
      </div>
      <div className='clarification-content'>
        <p>{question}</p>
        {options && options.length > 0 && (
          <div className='clarification-options'>
            {options.map((option, idx) => (
              <button
                key={idx}
                className='clarify-option'
                onClick={() => handleChoice(option)}
              >
                {option}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

Clarification.propTypes = {
  question: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  onChoice: PropTypes.func,
};

export default Clarification;
